import { render, staticRenderFns } from "./CopyStakeDashboardGraphs.vue?vue&type=template&id=4d13c09b&scoped=true&lang=pug"
import script from "./CopyStakeDashboardGraphs.vue?vue&type=script&lang=ts"
export * from "./CopyStakeDashboardGraphs.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeDashboardGraphs.vue?vue&type=style&index=0&id=4d13c09b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13c09b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCol,VRow,VSelect,VSlideYTransition})
